import { IServant, IIndexable } from 'core-ts-types';
import * as _4 from 'lodash4';

export interface ITreeNode extends IIndexable {}

export interface IBTreeMappingOptions {
  children: string;
}

/**
 * A B-tree is a tree with n children at every node
 */
export class BTreeServant implements IServant {
  private static OPTIONS: IBTreeMappingOptions = {
    children: 'children'
  };

  /**
   * @deprecated use BTreeServant.flatten
   */
  static toList = BTreeServant.flatten;

  /**
   * useful for converting a tree to a list to store in a Datasource
   * @param root top-level list of children
   * @param options configuration of the key which holds children
   */
  static flatten<T extends ITreeNode>(root: T[], options?: Partial<IBTreeMappingOptions>): T[] {
    return BTreeServant.__flatten(root, _.merge({}, BTreeServant.OPTIONS, options));
  }
  private static __flatten<T extends ITreeNode>(root: T[], options: IBTreeMappingOptions): T[] {
    return _4.reduce(
      root,
      (list: T[], node: T): T[] => {
        return (
          _4.isArray(node[options.children])
            ? [...list, node, ...BTreeServant.toList(node[options.children], options)]
            : [...list, node]
        ) as T[];
      },
      []
    );
  }

  /**
   * loop over each node element
   * @param root top-level list of children
   * @param options configuration of the key which holds children
   */
  static each<T extends ITreeNode>(root: T[], cb: (value: T) => void, options?: Partial<IBTreeMappingOptions>): T[] {
    BTreeServant.__each(root, cb, _.merge({}, BTreeServant.OPTIONS, options));
    return root;
  }
  private static __each<T extends ITreeNode>(root: T[], cb: (value: T) => void, options: IBTreeMappingOptions): void {
    _4.each(root, (node: T) => {
      if (_4.isArray(node[options.children])) {
        BTreeServant.toList(node[options.children], options);
      } else {
        cb(node);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./app/vendor/utility-ts-type/src/data_types/b_tree_servant.ts